import { render, staticRenderFns } from "./SignupWizardStepPassword.vue?vue&type=template&id=4405dc95&scoped=true&"
import script from "./SignupWizardStepPassword.vue?vue&type=script&lang=js&"
export * from "./SignupWizardStepPassword.vue?vue&type=script&lang=js&"
import style0 from "./SignupWizardStepPassword.vue?vue&type=style&index=0&id=4405dc95&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4405dc95",
  null
  
)

export default component.exports